import type { AddressStored } from "@jti/fe-common/types";

export const isHomeDeliveryAddressWithNoContactData = (address: unknown): address is AddressStored => {
  return (
    typeof address === "object" &&
    address !== null &&
    "streetName" in address &&
    "streetNumber" in address &&
    "postcode" in address &&
    "streetAdditional" in address &&
    "city" in address &&
    "countryCode" in address &&
    typeof address.streetName === "string" &&
    typeof address.streetNumber === "string" &&
    typeof address.postcode === "string" &&
    typeof address.streetAdditional === "string" &&
    typeof address.city === "string" &&
    typeof address.countryCode === "string"
  );
};
